import React from "react";

const getPacificDateInfo = (date = new Date()) => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const partValue = (type) => parts.find((part) => part.type === type)?.value;

  const year = partValue("year");
  const month = partValue("month");
  const day = partValue("day");
  const hour = Number(partValue("hour"));

  return { ymd: `${year}-${month}-${day}`, hour };
};

const previousDayYmd = (ymd) => {
  const [year, month, day] = ymd.split("-").map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  utcDate.setUTCDate(utcDate.getUTCDate() - 1);
  return utcDate.toISOString().slice(0, 10);
};

const Footer = ({ updated }) => {
  // Check the user-agent for Mac, iPad, or iPhone

  const { ymd, hour } = getPacificDateInfo();
  const isBetween8PmAndMidnightPacific = hour >= 20 && hour < 24;
  const summaryDate = isBetween8PmAndMidnightPacific ? ymd : previousDayYmd(ymd);
  const summaryLabel = isBetween8PmAndMidnightPacific
    ? "Today's Discord Summary"
    : "Yesterday's Discord Summary";
  const summaryUrl = `https://caltrain.live/summary/${summaryDate}-Summary.html`;

  return (
    <footer>
      <p>
        Updated: {updated}.{" "}
        <a href="https://www.linquist.com/tech/caltrain/">How this is calculated</a>.{" "}
        Contact: better@caltrain.live.{" "}
        <a href={summaryUrl}>{summaryLabel}</a>.
      </p>      
    </footer>
  );
};

export default Footer;
